export default __webpack_public_path__ + "static/media/ford.a49d164d.svg";